import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "./User.css";
import Pagination from "../Pagination/pagination";
import ListControls from "../ListControls/ListControls";
import ExportCsvButton from "../ExportCsvButton";
import SearchIcon from "@mui/icons-material/Search";
import Loader from "../../Loader/Loader";
import {
  blockuser,
  deleteuser,
  userlist,
  exportUsersCsv,
} from "../../service/Mainservice";
import moment from "moment";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Deletepopup from "../Vendor/Aresure";
import DeleteIcon from "@mui/icons-material/Delete";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import Tooltip from "@mui/material/Tooltip";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const UserList = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [searchvalue, setsearchvalue] = useState("");
  const [pagination, setpagination] = useState({ page: 1 });
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [id, setid] = useState();
  const [open, setOpen] = useState(false);
  const [showdelete, setshowdelete] = useState(false);
  const [filter, setFilter] = useState("all"); // 'all', 'active', 'suspended', 'banned'

  const navigate = useNavigate();

  useEffect(() => {
    getData(pagination.page);
  }, []);

  useEffect(() => {
    getData(1);
  }, [searchvalue, filter, sortBy, sortOrder]); // re-fetch when controls change

  const getData = async (page) => {
    try {
      setloading(true);
      const response = await userlist(page, searchvalue, filter, { sortBy, sortOrder });
      const idsToRemove = ["e910d9d1-1195-46ff-ae12-842a49ad7f6d"];
      setData(
        response.data.data.filter((item) => !idsToRemove.includes(item.id)),
      );
      setpagination(response.data.pagination);
      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handledelete = async () => {
    try {
      await deleteuser(id, "customer");
      getData(1);
      setshowdelete(false);
    } catch (error) {
      setOpen(true);
      if (error?.status === 401) {
        localStorage.clear();
        navigate("/");
      }
      setshowdelete(false);
    }
  };

  const handleunblock = async (id, action) => {
    try {
      await blockuser(id, "customer", action);
      getData(1);
      setshowdelete(false);
    } catch (error) {
      setOpen(true);
      if (error?.status === 401) {
        localStorage.clear();
        navigate("/");
      }
      setshowdelete(false);
    }
  };

  const onClose = () => {
    setshowdelete(false);
  };

  // Navigate to User Details
  const handleRowClick = (userId) => {
    navigate("/User_Details", {
      state: { id: userId },
    });
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">All Users</h1>
          <div className="searchicon">
            <SearchIcon />
            <input
              type="search"
              placeholder="Search by name, email, phone..."
              id="search"
              onChange={(e) => setsearchvalue(e.target.value)}
              autoComplete="off"
            />
          </div>
        </div>

        <ListControls sortOptions={[{value:"createdAt",label:"Created date"},{value:"fullName",label:"Name"},{value:"email",label:"Email"},{value:"totalOrders",label:"Orders"},{value:"totalSpent",label:"Total spent"}]} sortBy={sortBy} sortOrder={sortOrder} onSortByChange={setSortBy} onSortOrderChange={setSortOrder} />
        <ExportCsvButton
          exportRequest={exportUsersCsv}
          filters={{
            search: searchvalue,
            status: filter === "all" ? "" : filter,
            sortBy,
            sortOrder,
          }}
          filename="users.csv"
        />
        {/* ----- Filter Tabs (aligned with API) ----- */}
        <div className="filter_tabs">
          <button
            className={filter === "all" ? "filter_active" : ""}
            onClick={() => setFilter("all")}
          >
            All
          </button>
          <button
            className={filter === "active" ? "filter_active" : ""}
            onClick={() => setFilter("active")}
          >
            Active
          </button>
          <button
            className={filter === "suspended" ? "filter_active" : ""}
            onClick={() => setFilter("suspended")}
          >
            Suspended
          </button>
          <button
            className={filter === "banned" ? "filter_active" : ""}
            onClick={() => setFilter("banned")}
          >
            Banned
          </button>
        </div>

        {data.length > 0 ? (
          <div className="data_table_over">
            <table className="data_table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Total Orders</th>
                  <th>Total Spent</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr
                    key={item.id}
                    onClick={() => handleRowClick(item.id)}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="user_name">
                      {item.image ? (
                        <img
                          src={item.image}
                          alt="profile"
                          className="data_userdetails_img"
                        />
                      ) : (
                        <div className="data_userdetails_img">
                          <PersonOutlineIcon />
                        </div>
                      )}
                      {item.fullName}
                    </td>
                    <td>{item.email}</td>
                    <td>{item.mobilenumber}</td>
                    <td>{item.totalOrders || 0}</td>
                    <td>${item.totalSpent || 0}</td>
                    <td>
                      {item.isBlocked ? (
                        <span className="status_badge banned">Banned</span>
                      ) : item.suspendedUntil ? (
                        <span className="status_badge suspended">
                          Suspended
                        </span>
                      ) : (
                        <span
                          className={`status_badge ${item.status?.toLowerCase()}`}
                        >
                          {item?.status || "Active"}
                        </span>
                      )}
                    </td>
                    <td>
                      <div className="action_buttons">
                        <Tooltip title="View Details" arrow placement="top">
                          <RemoveRedEyeIcon
                            sx={{
                              color: "#3b82f6",
                              fontSize: "25px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRowClick(item.id);
                            }}
                          />
                        </Tooltip>

                        {item.isBlocked ? (
                          <Tooltip title="Unblock User" arrow placement="top">
                            <BlockIcon
                              sx={{
                                color: "#ef4444",
                                fontSize: "22px",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleunblock(item.id, "unblock");
                              }}
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Block User" arrow placement="top">
                            <CheckCircleIcon
                              sx={{
                                color: "#22c55e",
                                fontSize: "22px",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleunblock(item.id, "block");
                              }}
                            />
                          </Tooltip>
                        )}

                        <Tooltip title="Delete User" arrow placement="top">
                          <DeleteIcon
                            sx={{
                              color: "var(--red)",
                              fontSize: "28px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setid(item.id);
                              setshowdelete(true);
                            }}
                          />
                        </Tooltip>
                      </div>{" "}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="nodata">No users match the current filter.</p>
        )}

        <Pagination pagedata={pagination} onPageChange={getData} />
      </div>

      <Deletepopup
        isOpen={showdelete}
        setisOpen={setshowdelete}
        handledelete={handledelete}
        onClose={onClose}
      />

      {loading && <Loader />}
    </>
  );
};

export default UserList;
